const menuCodeMapping = [
  {
    ServiceCategoryCode: "main",
    code: "main",
    path: "/",
    name: "Main",
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S001",
    path: "/sales",
    name: "Sales",
    iconName : "S",
    iconColor: "#3F9FD2"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S002",
    path: "/weekly",
    name: "Weekly",
    iconName : "W",
    iconColor: "#C59613"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S003",
    path: "/nonReimbursement",
    name: "NonReimbursement",
    iconName : "N",
    iconColor: "#C361B0"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S004",
    path: "/gis",
    name: "GIS",
    iconName : "G",
    iconColor: "#F75A3A"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S005",
    path: "/sob",
    name: "SoB",
    iconName : "O",
    iconColor: "#6F9E60"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S006",
    path: "/combinationtherapy1",
    name: "CombinationTherapy1",
    iconName : "C1",
    iconColor: "#AAAAAA"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S007",
    path: "/combinationtherapynew",
    name: "CombinationTherapy New",
    iconName : "CN",
    iconColor: "#AAAAAA"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S008",
    path: "/combinationtherapy2",
    name: "CombinationTherapy2",
    iconName : "C2",
    iconColor: "#AAAAAA"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S009",
    path: "/diagnosis1",
    name: "Diagnosis1",
    iconName : "D1",
    iconColor: "#887472"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S010",
    path: "/diagnosis2",
    name: "Diagnosis2",
    iconName : "D2",
    iconColor: "#887472"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S011",
    path: "/generic",
    name: "Generic",
    iconName : "E",
    iconColor: "#9593E9"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S012",
    path: "/patternP",
    name: "Pattern_Product",
    iconName : "PP",
    iconColor: "#D9A91C"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S016",
    path: "/patternM",
    name: "Pattern_Molecule",
    iconName : "PM",
    iconColor: "#4D69D3"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S017",
    path: "/patternA",
    name: "Pattern_ATC",
    iconName : "PA",
    iconColor: "#327455"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S013",
    path: "/dosage",
    name: "Dosage",
    iconName : "D",
    iconColor: "#E1866D"
  },
  {
    ServiceCategoryCode: "SC002",
    code: "SC002",
    path: "/clinic",
    name: "Clinic",
  },
  {
    ServiceCategoryCode: "SC003",
    code: "SC003",
    path: "/hira",
    name: "Hira",
  },
  {
    ServiceCategoryCode: "SC002",
    code: "S014",
    path: "/vaccinesalesold",
    name: "VaccineSalesOld",
    iconName : "VS",
    iconColor: "#773838"
  },
  {
    ServiceCategoryCode: "SC004",
    code: "S020",
    path: "/notice",
    name: "Notice",
  },
  {
    ServiceCategoryCode: "SC004",
    code: "S021",
    path: "/archives",
    name: "Archives",
  },
  {
    ServiceCategoryCode: "SC999",
    code: "S999",
    path: "/DrugInfo",
    name: "DrugInfo",
  },
  {
    ServiceCategoryCode: "SC005",
    code: "S015",
    path: "/hcdsales",
    name: "SoB2",
    iconName : "S",
    iconColor: "#224e88"
  },
  {
    ServiceCategoryCode: "SC005",
    code: "S024",
    path: "/Handling",
    name: "Handling",
    iconName : "H",
    iconColor: "#a36b36"
  },
  {
    ServiceCategoryCode: "SC005",
    code: "S025",
    path: "/Switching",
    name: "Switching",
    iconName : "O",
    iconColor: "#539daa"
  },
  {
    ServiceCategoryCode: "SC002",
    code: "S026",
    path: "/CL_Diagnosis1",
    name: "CL_Diagnosis1",
    iconName : "D1",
    iconColor: "#E89D87"
  },
  {
    ServiceCategoryCode: "SC002",
    code: "S027",
    path: "/vaccinesales",
    name: "VaccineSales",
    iconName : "VS",
    iconColor: "#02B5EB"
  },
  {
    ServiceCategoryCode: "SC004",
    code: "S032",
    path: "/Old_D1_Sales",
    name: "Old_D1_Sales",
    iconName : "S",
    iconColor: "#3F9FD2"
  },
  {
    ServiceCategoryCode: "SC010",
    code: "S028",
    path: "/Old_D1_Sales",
    name: "Old_D1_Sales",
    iconName : "S",
    iconColor: "#3F9FD2"
  },
  {
    ServiceCategoryCode: "SC011",
    code: "S029",
    path: "/Old_D1_Non",
    name: "Old_D1_Non",
    iconName : "N",
    iconColor: "#C361B0"
  },
  {
    ServiceCategoryCode: "SC010",
    code: "S030",
    path: "/Old_UP_Sales",
    name: "Old_UP_Sales",
    iconName : "S",
    iconColor: "#3F9FD2"
  },
  {
    ServiceCategoryCode: "SC011",
    code: "S031",
    path: "/Old_UP_Non",
    name: "Old_UP_Non",
    iconName : "N",
    iconColor: "#C361B0"
  },
  {
    ServiceCategoryCode: "SC012",
    code: "S033",
    path: "/OTC_Sales",
    name: "OTC_Sales",
    iconName : "S",
    iconColor: "#22C55E"
  },
  {
    ServiceCategoryCode: "SC012",
    code: "S034",
    path: "/OTC_Consumer",
    name: "OTC_Consumer",
    iconName : "C",
    iconColor: "#36c5b9"
  },
  {
    ServiceCategoryCode: "SC012",
    code: "S035",
    path: "/OTC_Price",
    name: "OTC_Price",
    iconName : "P",
    iconColor: "#0c5a1f"
  },
  {
    ServiceCategoryCode: "SC001",
    code: "S036",
    path: "/Subst",
    name: "Subst",
    iconName : "S",
    iconColor: "#0c5a1f"
  },
];

export default menuCodeMapping;
